import React, { useState, useEffect, useRef } from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Inject,
} from "@syncfusion/ej2-react-grids";
import { Header } from "../Components";
import axios from "axios";
import {
  FaSearch,
  FaTrash,
  FaTimes,
  FaFileExcel,
  FaFilePdf,
  FaPlus,
  FaEdit,
} from "react-icons/fa";
import { useBaseUrl } from "../Contexts/BaseUrlContext";
import { useStateContext } from "../Contexts/ContextProvider";
// News Grid column configuration
const newsGrid = [
  {
    field: "id",
    headerText: "ID",
    width: 80,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">ID</span>,
  },
  {
    field: "title",
    headerText: "Title",
    width: 200,
    textAlign: "Left",
    headerTemplate: () => <span className="font-bold">Title</span>,
  },
  //  { field: 'description', headerText: 'Title', width: 200, textAlign: 'Left', headerTemplate: () => <span className="font-bold">Title</span> },
  {
    field: "post_date_time",
    headerText: "Posted On",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Posted On</span>,
  },
  {
    field: "description",
    headerText: "Description",
    width: 200,
    textAlign: "Left",
    headerTemplate: () => <span className="font-bold">Description</span>,
  },
  // {
  //   field: 'image_url',
  //   headerText: 'Image',
  //   width: 100,
  //   textAlign: 'Center',
  //   template: (props) => (
  //     props.image_url ? <img src={props.image_url} alt="News" className="w-12 h-12 object-cover rounded" /> : <span>No Image</span>
  //   ),
  //   headerTemplate: () => <span className="font-bold">Description</span>,
  // },
  {
    field: "Actions",
    headerText: "Actions",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Actions</span>,
    template: (props) => (
      <div className="flex justify-center gap-3">
        <button
          className="text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.editNewsHandler(props)}
          title="Edit"
        >
          <FaEdit size={18} />
        </button>
        <button
          className="text-red-600 hover:text-red-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.deleteNewsHandler(props.id)}
          title="Delete"
        >
          <FaTrash size={18} />
        </button>
      </div>
    ),
  },
];

// Records Grid column configuration
const recordsGrid = [
  {
    field: "id",
    headerText: "ID",
    width: 80,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">ID</span>,
  },
  {
    field: "name",
    headerText: "Name",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Name</span>,
  },
  {
    field: "company",
    headerText: "Company",
    width: 150,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Company</span>,
  },
  {
    field: "designation",
    headerText: "designation",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Designation</span>,
  },
  {
    field: "batch",
    headerText: "Batch",
    width: 100,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Batch</span>,
  },
  {
    field: "photo",
    headerText: "Photo",
    width: 100,
    textAlign: "Center",
    template: (props) => (
      <img
        src={props.photo}
        alt="Record"
        className="w-12 h-12 object-cover rounded"
      />
    ),
    headerTemplate: () => <span className="font-bold">Photo</span>,
  },
  {
    field: "Actions",
    headerText: "Actions",
    width: 120,
    textAlign: "Center",
    headerTemplate: () => <span className="font-bold">Actions</span>,
    template: (props) => (
      <div className="flex justify-center gap-3">
        <button
          className="text-blue-600 hover:text-blue-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.editRecordHandler(props)}
          title="Edit"
        >
          <FaEdit size={18} />
        </button>
        <button
          className="text-red-600 hover:text-red-800 transition-transform transform hover:scale-110 focus:outline-none"
          onClick={() => props.deleteRecordHandler(props.id)}
          title="Delete"
        >
          <FaTrash size={18} />
        </button>
      </div>
    ),
  },
];

const Placement = () => {
  const [newsData, setNewsData] = useState([]);
  const [recordsData, setRecordsData] = useState([]);
  const [selectedNews, setSelectedNews] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [newsSearchTerm, setNewsSearchTerm] = useState("");
  const [recordsSearchTerm, setRecordsSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isAddNewsModalOpen, setIsAddNewsModalOpen] = useState(false);
  const [isEditNewsModalOpen, setIsEditNewsModalOpen] = useState(false);
  const [isAddRecordModalOpen, setIsAddRecordModalOpen] = useState(false);
  const [isEditRecordModalOpen, setIsEditRecordModalOpen] = useState(false);
  const [newsFormData, setNewsFormData] = useState({
    title: "",
    image: null,
    imagePreview: null,
  });
  const [recordFormData, setRecordFormData] = useState({
    student_name: "",
    company_name: "",
    branch: "",
    batch: "",
    photo: null,
    photoPreview: null,
  });

  const { baseUrl } = useBaseUrl();

  const newsGridRef = useRef(null);
  const recordsGridRef = useRef(null);

  const API_URL = process.env.REACT_APP_API_URL || `${baseUrl}placement.php`;

  // Validate news form
  const validateNewsForm = (data) => {
    if (!data.title) return "Title is required.";
    return null;
  };

  // Validate record form
  const validateRecordForm = (data, isAdd) => {
    if (!data.student_name) return "Name is required.";
    if (!data.company_name) return "Company is required.";
    if (!data.branch) return "Designation is required.";
    if (!data.batch) return "Batch is required.";
    if (isAdd && !data.photo) return "Photo is required.";
    return null;
  };

  // Fetch news data
  useEffect(() => {
    fetchNews();
    fetchRecords();
  }, []);

  const fetchNews = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("action", "get-placement-news");
      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      if (response.data.status) {
        setNewsData(response.data.data || []);
      } else {
        setErrorMessage(response.data.error || "Failed to fetch news.");
      }
    } catch (error) {
      setErrorMessage(
        "Error connecting to the server: " +
          (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRecords = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("action", "get-placement");
      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      console.log(response);
      if (response.data.status) {
        setRecordsData(response.data.data || []);
      } else {
        setErrorMessage(response.data.error || "Failed to fetch records.");
      }
    } catch (error) {
      setErrorMessage(
        "Error connecting to the server: " +
          (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle add news
  const handleAddNews = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    const error = validateNewsForm(newsFormData);
    if (error) {
      setErrorMessage(error);
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("action", "add-placement-news");
      formData.append("title", newsFormData.title);
      formData.append("description", newsFormData.description);
      formData.append("post_date_time", newsFormData.post_date_time);
      // if (newsFormData.image) {
      //   formData.append('image', newsFormData.image);
      // }

      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      if (response.data.status) {
        fetchNews();
        // setNewsData([...newsData, response.data.data]);
        setIsAddNewsModalOpen(false);
        setNewsFormData({ title: "", image: null, imagePreview: null });
        setErrorMessage("");
        alert("News added successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to add news.");
      }
    } catch (error) {
      setErrorMessage(
        "Failed to add news: " + (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit news
  const handleEditNews = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    const error = validateNewsForm(newsFormData);
    if (error) {
      setErrorMessage(error);
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("action", "update-placement-news");
      formData.append("id", selectedNews.id);
      formData.append("title", newsFormData.title);
      formData.append("description", newsFormData.description);
      formData.append("post_date_time", newsFormData.post_date_time);
      // if (newsFormData.image) {
      //   formData.append('image', newsFormData.image);
      // }

      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      if (response.data.status) {
        fetchNews();
        // setNewsData(newsData.map(item => item.id === selectedNews.id ? response.data.data : item));
        setIsEditNewsModalOpen(false);
        setNewsFormData({ title: "", image: null, imagePreview: null });
        setSelectedNews(null);
        setErrorMessage("");
        alert("News updated successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to update news.");
      }
    } catch (error) {
      setErrorMessage(
        "Failed to update news: " +
          (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete news
  const deleteNewsHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this news?")) {
      setIsLoading(true);
      setErrorMessage("");
      try {
        const formData = new FormData();
        formData.append("action", "delete-placement-news");
        formData.append("id", id);

        const response = await axios.post(API_URL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });

        if (response.data.status) {
          setNewsData(newsData.filter((item) => item.id !== id));
          setErrorMessage("");
          alert("News deleted successfully.");
        } else {
          setErrorMessage(response.data.error || "Failed to delete news.");
        }
      } catch (error) {
        setErrorMessage(
          "Failed to delete news: " +
            (error.response?.data?.error || error.message)
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Handle add record
  const handleAddRecord = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    const error = validateRecordForm(recordFormData, true);
    if (error) {
      setErrorMessage(error);
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      // console.log(recordFormData);
      formData.append("action", "add-placement");
      formData.append("student_name", recordFormData.student_name);
      formData.append("company_name", recordFormData.company_name);
      formData.append("branch", recordFormData.branch);
      formData.append("batch", recordFormData.batch);
      formData.append("photo", recordFormData.photo);

      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });
      // console.log(response)
      if (response.data.status) {
        fetchRecords();
        // setRecordsData([...recordsData, response.data.data]);
        setIsAddRecordModalOpen(false);

        setRecordFormData({
          student_name: "",
          company_name: "",
          branch: "",
          batch: "",
          photo: null,
          photoPreview: null,
        });
        setErrorMessage("");
        alert("Record added successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to add record.");
      }
    } catch (error) {
      setErrorMessage(
        "Failed to add record: " +
          (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle edit record
  const handleEditRecord = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");

    const error = validateRecordForm(recordFormData, false);
    if (error) {
      setErrorMessage(error);
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("action", "update-placement");
      formData.append("id", selectedRecord.id);
      formData.append("student_name", recordFormData.student_name);
      formData.append("company_name", recordFormData.company_name);
      formData.append("branch", recordFormData.branch);
      formData.append("batch", recordFormData.batch);
      if (recordFormData.photo) {
        formData.append("photo", recordFormData.photo);
      }

      const response = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
      });

      if (response.data.status) {
        fetchRecords();
        // setRecordsData(recordsData.map(item => item.id === selectedRecord.id ? response.data.data : item));
        setIsEditRecordModalOpen(false);
        setRecordFormData({
          student_name: "",
          company_name: "",
          branch: "",
          batch: "",
          photo: null,
          photoPreview: null,
        });
        setSelectedRecord(null);
        setErrorMessage("");
        alert("Record updated successfully.");
      } else {
        setErrorMessage(response.data.error || "Failed to update record.");
      }
    } catch (error) {
      setErrorMessage(
        "Failed to update record: " +
          (error.response?.data?.error || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete record
  const deleteRecordHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      setIsLoading(true);
      setErrorMessage("");
      try {
        const formData = new FormData();
        formData.append("action", "delete-placement");
        formData.append("id", id);

        const response = await axios.post(API_URL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });

        if (response.data.status) {
          setRecordsData(recordsData.filter((item) => item.id !== id));
          setErrorMessage("");
          alert("Record deleted successfully.");
        } else {
          setErrorMessage(response.data.error || "Failed to delete record.");
        }
      } catch (error) {
        setErrorMessage(
          "Failed to delete record: " +
            (error.response?.data?.error || error.message)
        );
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Handle edit news action
  const editNewsHandler = (news) => {
    setSelectedNews(news);
    setNewsFormData({
      title: news.title,
      image: null,
      imagePreview: news.image_url,
    });
    setIsEditNewsModalOpen(true);
  };

  // Handle edit record action
  const editRecordHandler = (record) => {
    setSelectedRecord(record);
    setRecordFormData({
      student_name: record.name,
      company_name: record.company,
      branch: record.designation,
      batch: record.batch,
      photo: null,
      photoPreview: record.photo,
    });
    setIsEditRecordModalOpen(true);
  };

  // Image preview handlers
  const handleNewsImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setNewsFormData({
        ...newsFormData,
        image: file,
        imagePreview: previewUrl,
      });
    }
  };

  const handleRecordPhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setRecordFormData({
        ...recordFormData,
        photo: file,
        photoPreview: previewUrl,
      });
    }
  };

  // Search filters
  const filteredNewsData = newsData.filter((item) =>
    item.title?.toLowerCase().includes(newsSearchTerm.toLowerCase())
  );

  const filteredRecordsData = recordsData.filter(
    (item) =>
      item.name?.toLowerCase().includes(recordsSearchTerm.toLowerCase()) ||
      item.company?.toLowerCase().includes(recordsSearchTerm.toLowerCase()) ||
      item.designation
        ?.toLowerCase()
        .includes(recordsSearchTerm.toLowerCase()) ||
      item.batch?.toLowerCase().includes(recordsSearchTerm.toLowerCase())
  );

  // Inject handlers into grid data
  const newsGridData = filteredNewsData.map((item) => ({
    ...item,
    editNewsHandler,
    deleteNewsHandler,
  }));

  const recordsGridData = filteredRecordsData.map((item) => ({
    ...item,
    editRecordHandler,
    deleteRecordHandler,
  }));

  const { setCurrentColor, setCurrentMode, currentMode } = useStateContext();

  useEffect(() => {
    const currentThemeColor = localStorage.getItem("colorMode");
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  return (
    <div
      style={currentMode === "Dark" ? { backgroundColor: "#20232A" } : {}}
      className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 animate-fadeIn bg-gray-100 min-h-screen"
    >
      <Header category="Dashboard" title="Placement Management" />

      {/* Error Message */}
      {errorMessage && (
        <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
          {errorMessage}
        </div>
      )}

      {/* News Section */}
      <div className="mb-12">
        <h2
          className={
            currentMode === "Dark"
              ? "text-2xl font-bold text-white mb-4"
              : "text-2xl font-bold text-gray-900 mb-4"
          }
        >
          Placement News
        </h2>

        {/* Search and Controls */}
        <div className="mb-6 flex flex-col sm:flex-row gap-4">
          <div className="relative flex-1">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search news by title..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 bg-white shadow-sm"
              value={newsSearchTerm}
              onChange={(e) => setNewsSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex gap-2">
            <button
              className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300 shadow-md"
              onClick={() => {
                setNewsFormData({ title: "", image: null, imagePreview: null });
                setIsAddNewsModalOpen(true);
              }}
            >
              <FaPlus className="mr-2" /> Add News
            </button>
            <button
              className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 shadow-md disabled:opacity-50"
              onClick={() => newsGridRef.current.excelExport()}
              disabled={isLoading}
            >
              <FaFileExcel className="mr-2" /> Export Excel
            </button>
            <button
              className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md disabled:opacity-50"
              onClick={() => newsGridRef.current.pdfExport()}
              disabled={isLoading}
            >
              <FaFilePdf className="mr-2" /> Export PDF
            </button>
          </div>
        </div>

        {/* Loading Indicator */}
        {isLoading && (
          <div className="flex justify-center items-center py-4">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* News Grid */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <GridComponent
            ref={newsGridRef}
            id="newsGrid"
            dataSource={newsGridData}
            allowPaging={true}
            allowSorting={true}
            allowExcelExport={true}
            allowPdfExport={true}
            allowFiltering={true}
            allowResizing={true}
            pageSettings={{ pageSize: 10, pageSizes: [10, 20, 50] }}
            filterSettings={{ type: "Menu", showFilterBarStatus: true }}
          >
            <ColumnsDirective>
              {newsGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject
              services={[
                Resize,
                Sort,
                ContextMenu,
                Filter,
                Page,
                ExcelExport,
                PdfExport,
              ]}
            />
          </GridComponent>
        </div>
      </div>

      {/* Records Section */}
      <div>
        <h2
          className={
            currentMode === "Dark"
              ? "text-2xl font-bold text-white mb-4"
              : "text-2xl font-bold text-gray-900 mb-4"
          }
        >
          Placement Records
        </h2>

        {/* Search and Controls */}
        <div className="mb-6 flex flex-col sm:flex-row gap-4">
          <div className="relative flex-1">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search by name, company, designation, or batch..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 bg-white shadow-sm"
              value={recordsSearchTerm}
              onChange={(e) => setRecordsSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex gap-2">
            <button
              className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-300 shadow-md"
              onClick={() => {
                setRecordFormData({
                  name: "",
                  company: "",
                  designation: "",
                  batch: "",
                  photo: null,
                  photoPreview: null,
                });
                setIsAddRecordModalOpen(true);
              }}
            >
              <FaPlus className="mr-2" /> Add Record
            </button>
            <button
              className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-300 shadow-md disabled:opacity-50"
              onClick={() => recordsGridRef.current.excelExport()}
              disabled={isLoading}
            >
              <FaFileExcel className="mr-2" /> Export Excel
            </button>
            <button
              className="flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-300 shadow-md disabled:opacity-50"
              onClick={() => recordsGridRef.current.pdfExport()}
              disabled={isLoading}
            >
              <FaFilePdf className="mr-2" /> Export PDF
            </button>
          </div>
        </div>

        {/* Loading Indicator */}
        {isLoading && (
          <div className="flex justify-center items-center py-4">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* Records Grid */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <GridComponent
            ref={recordsGridRef}
            id="recordsGrid"
            dataSource={recordsGridData}
            allowPaging={true}
            allowSorting={true}
            allowExcelExport={true}
            allowPdfExport={true}
            allowFiltering={true}
            allowResizing={true}
            pageSettings={{ pageSize: 10, pageSizes: [10, 20, 50] }}
            filterSettings={{ type: "Menu", showFilterBarStatus: true }}
          >
            <ColumnsDirective>
              {recordsGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject
              services={[
                Resize,
                Sort,
                ContextMenu,
                Filter,
                Page,
                ExcelExport,
                PdfExport,
              ]}
            />
          </GridComponent>
        </div>
      </div>

      {/* Add News Modal */}
      {isAddNewsModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Add News</h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsAddNewsModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleAddNews} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={newsFormData.title}
                  onChange={(e) =>
                    setNewsFormData({ ...newsFormData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Description
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={newsFormData.description}
                  onChange={(e) =>
                    setNewsFormData({
                      ...newsFormData,
                      description: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Date & Time
                </label>
                <input
                  type="datetime-local"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={newsFormData.post_date_time}
                  onChange={(e) => {
                    const isoString = e.target.value;
                    const formatted = isoString.replace("T", " ") + ":00"; // convert to "YYYY-MM-DD HH:mm:ss"
                    setNewsFormData({
                      ...newsFormData,
                      post_date_time: formatted,
                    });
                  }}
                  required
                />
              </div>

              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsAddNewsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Add News
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit News Modal */}
      {isEditNewsModalOpen && selectedNews && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">Edit News</h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsEditNewsModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleEditNews} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={newsFormData.title}
                  onChange={(e) =>
                    setNewsFormData({ ...newsFormData, title: e.target.value })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Discription
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={newsFormData.description}
                  onChange={(e) =>
                    setNewsFormData({
                      ...newsFormData,
                      description: e.target.value,
                    })
                  }
                  required
                />
                {/* {newsFormData.imagePreview && (
                  <img src={newsFormData.imagePreview} alt="Preview" className="mt-2 w-24 h-24 object-cover rounded" />
                )} */}
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsEditNewsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Update News
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Add Record Modal */}
      {isAddRecordModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Add Placement Record
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsAddRecordModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleAddRecord} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.student_name}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      student_name: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Company
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.company_name}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      company_name: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Designation
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.branch}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      branch: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Batch
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.batch}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      batch: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Photo
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={handleRecordPhotoChange}
                  required
                />
                {recordFormData.photoPreview && (
                  <img
                    src={recordFormData.photoPreview}
                    alt="Preview"
                    className="mt-2 w-24 h-24 object-cover rounded"
                  />
                )}
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsAddRecordModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Add Record
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Record Modal */}
      {isEditRecordModalOpen && selectedRecord && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-2xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Edit Placement Record
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 transition"
                onClick={() => setIsEditRecordModalOpen(false)}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <form onSubmit={handleEditRecord} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.student_name}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      name: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Company
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.company_name}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      company_name: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Branch
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.branch}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      branch: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Batch
                </label>
                <input
                  type="text"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={recordFormData.batch}
                  onChange={(e) =>
                    setRecordFormData({
                      ...recordFormData,
                      batch: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Photo (optional)
                </label>
                <input
                  type="file"
                  accept="image/*"
                  className="w-full p-2 border border-gray-300 rounded-lg"
                  onChange={handleRecordPhotoChange}
                />
                {recordFormData.photoPreview && (
                  <img
                    src={recordFormData.photoPreview}
                    alt="Preview"
                    className="mt-2 w-24 h-24 object-cover rounded"
                  />
                )}
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                  onClick={() => setIsEditRecordModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
                  disabled={isLoading}
                >
                  Update Record
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Placement;
